import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Register from '@/components/Register'
import Login from '@/components/Login'
import Forget from '@/components/Forget'
import MemberInfo from '@/components/MemberInfo'
import ChangePassword from '@/components/ChangePassword'
import Category from '@/components/Category'
import Post from '@/components/Post'
import CardInfo from '@/components/CardInfo'
import CardInfoDetail from '@/components/CardInfoDetail'
import MProductList from '@/components/MProductList'
import ProductList from '@/components/ProductList'
import ProductPointList from '@/components/ProductPointList'
import MProduct from '@/components/MProduct'
import Product from '@/components/Product'
import ProductPoint from '@/components/ProductPoint'
import ProductBuy from '@/components/ProductBuy'
import MProductBuy from '@/components/MProductBuy'
import OrderList from '@/components/OrderList'
import OrderInfo from '@/components/OrderInfo' 
import QRCode from '@/components/QRCode'
import MQRCode from '@/components/MQRCode'
import Coupon from '@/components/Coupon'
import CardLost from '@/components/CardLost'
import TicketLog from '@/components/TicketLog'
import MTicketLog from '@/components/MTicketLog'
import TradeRecord from '@/components/TradeRecord'
import Map from '@/components/Map'
import OldLogin from '@/components/OldLogin'
import ExtendedTime from '@/components/ExtendedTime'
import DonateTicket from '@/components/DonateTicket'
import PointOrderList from '@/components/PointOrderList'
import OtherList from '@/components/OtherList'
import CarbonReduction from '@/components/CarbonReduction'
import CardBind from '@/components/CardBind'
import SProductList from '@/components/SProductList'
import PushList from '@/components/PushList'
import MemberCoupon from '@/components/MemberCoupon'
import MemberCouponMain from '@/components/MemberCouponMain'
import InvitEvent from '@/components/InvitEvent'
import DownloadApp from '@/components/DownloadApp'

// import Product from '@/components/Product'
// import OrderInfo from '@/components/OrderInfo'
// import My from '@/components/My'
// import Member from '@/components/Member'
// import OrderList from '@/components/OrderList'
// import QRCode from '@/components/QRCode'
// import TicketLog from '@/components/TicketLog'
// import DonateTicket from '@/components/DonateTicket'

// import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/Register',
      name: 'Register',
      component: Register
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Forget',
      name: 'Forget',
      component: Forget
    },
    {
      path: '/MemberInfo',
      name: 'MemberInfo',
      component: MemberInfo
    },
    {
      path: '/ChangePassword',
      name: 'ChangePassword',
      component: ChangePassword
    },
    {
      path: '/Category/:CId',
      name: 'Category',
      component: Category
    },
    {
      path: '/Post/:PId',
      name: 'Post',
      component: Post
    },
    {
      path: '/CardInfo',
      name: 'CardInfo',
      component: CardInfo
    },
    {
      path: '/CardInfoDetail',
      name: 'CardInfoDetail',
      component: CardInfoDetail
    },
    {
      path: '/MProductList',
      name: 'MProductList',
      component: MProductList,
      props: route => ({ type: 'M' })
    },  
    {
      path: '/ProductList',
      name: 'ProductList',
      component: ProductList
    },  
    {
      path: '/ProductPointList',
      name: 'ProductPointList',
      component: ProductPointList
    },
    {
      path: '/MProduct/:o_maas_pt_seq',
      name: 'MProduct',
      component: MProduct
    },
    {
      path: '/MProductBuy/:o_maas_pt_seq',
      name: 'MProductBuy',
      component: MProductBuy
    }, 
    {
      path: '/Product/:PRId',
      name: 'Product',
      component: Product
    }, 
    {
      path: '/ProductPoint/:PPId',
      name: 'ProductPoint',
      component: ProductPoint
    }, 
    {
      path: '/ProductBuy/:PRId',
      name: 'ProductBuy',
      component: ProductBuy
    }, 
    {
     path: '/OrderList',
     name: 'OrderList',
     component: OrderList
    },
    {
      path: '/OrderInfo/:OrderId',
      name: 'OrderInfo',
      component: OrderInfo
    },
    {
      path: '/QRCode',
      name: 'QRCode',
      component: QRCode
    },
    {
      path: '/MQRCode',
      name: 'MQRCode',
      component: MQRCode
    },
    {
      path: '/Coupon',
      name: 'Coupon',
      component: Coupon
    },
    {
      path: '/CardLost',
      name: 'CardLost',
      component: CardLost
    },
    {
      path: '/TicketLog/:TId',
      name: 'TicketLog',
      component: TicketLog
    },
    {
      path: '/MTicketLog/:o_maas_so_seq',
      name: 'MTicketLog',
      component: MTicketLog
    },
    {
      path: '/TradeRecord',
      name: 'TradeRecord',
      component: TradeRecord
    },
    {
      path: '/Map',
      name: 'Map',
      component: Map
    },
    {
      path: '/OldLogin',
      name: 'OldLogin',
      component: OldLogin
    },
    {
      path: '/ExtendedTime',
      name: 'ExtendedTime',
      component: ExtendedTime
    },
    {
      path: '/DonateTicket',
      name: 'DonateTicket',
      component: DonateTicket
    },
    {
      path: '/PointOrderList/:o_maas_so_nbr',
      name: 'PointOrderList',
      component: PointOrderList
    },
    {
      path: '/OtherList',
      name: 'OtherList',
      component: OtherList
    },
    {
      path: '/CarbonReduction',
      name: 'CarbonReduction',
      component: CarbonReduction
    },
    {
      path: '/CardBind',
      name: 'CardBind',
      component: CardBind
    },
    {
      path: '/SProductList',
      name: 'SProductList',
      component: SProductList
    },  
    {
      path: '/SProductBuy/:o_maas_pt_seq',
      name: 'SProductBuy',
      component: MProductBuy
    }, 
    {
      path: '/PushList',
      name: 'PushList',
      component: PushList
    },  
    {
      path: '/MemberCoupon',
      name: 'MemberCoupon',
      component: MemberCoupon
    },  
    {
      path: '/MemberCouponMain/:CPLId',
      name: 'MemberCouponMain',
      component: MemberCouponMain
    },  
    {
      path: '/InvitEvent',
      name: 'InvitEvent',
      component: InvitEvent
    },  
    {
      path: '/DownloadApp',
      name: 'DownloadApp',
      component: DownloadApp
    },  
    // {
    //   path: '/OrderInfo/:OrderId',
    //   name: 'OrderInfo',
    //   component: OrderInfo
    // },
    // {
    //   path: '/My',
    //   name: 'My',
    //   component: My
    // },
    // {
    //   path: '/Member',
    //   name: 'Member',
    //   component: Member
    // },
    // {
    //   path: '/QRCode',
    //   name: 'QRCode',
    //   component: QRCode
    // },
    // {
    //   path: '/TicketLog/:TId',
    //   name: 'TicketLog',
    //   component: TicketLog
    // },
    // {

    // {
    //   path: '/Test',
    //   name: 'Test',
    //   component: Test
    // }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js